import { render, staticRenderFns } from "./configuration-local-assays-protocols-modal-basic-form.vue?vue&type=template&id=00913b64&scoped=true&"
import script from "./configuration-local-assays-protocols-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-protocols-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-protocols-modal-basic-form.scss?vue&type=style&index=0&id=00913b64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00913b64",
  null
  
)

export default component.exports